import {CommonModule} from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule, provideAppInitializer } from '@angular/core';
import {ShareModule} from '@/share/share.module';
import {BrowserModule} from '@angular/platform-browser';
import {SpinnerComponent} from './components/spinner/spinner.component';
import {TabNavComponent} from './components/tab-nav/tab-nav.component';
import {TabNavContainerComponent} from './components/tab-nav-container/tab-nav-container.component';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {HttpLoaderFactory} from 'src/app/share/util/loader-factory/loader-factory';
import {LazyLoaderModule} from 'src/app/core/loader/lazy-loader.module';
import {
  defineCustomElements as defineCustomerExperienceComponent
} from 'src/assets/vendor/customer-experience-browser-client/dist/loader';
import {ConstructUrlPipe} from 'src/app/share/pipes/construct-url/construct-url.pipe';
import {ModalsOverlayFixDirective} from 'src/app/modules/search/directives/modals-overlay-fix.directive';
import {DownloadModule} from "./feature-modules/download/download.module";
import {CatalogModule} from "./feature-modules/catalog/catalog.module";
import {WebsiteModule} from "./feature-modules/website/website.module";

@NgModule({
  declarations: [
    SpinnerComponent,
    TabNavComponent,
    TabNavContainerComponent,
    ConstructUrlPipe,
    ModalsOverlayFixDirective
  ],
  schemas: [
    NO_ERRORS_SCHEMA,
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    SpinnerComponent,
    TabNavComponent,
    ShareModule,
    LazyLoaderModule,
    ConstructUrlPipe,
    ModalsOverlayFixDirective
  ], imports: [
    CommonModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ShareModule.forRoot(),
    LazyLoaderModule,
    DownloadModule,
    CatalogModule,
    WebsiteModule], providers: [
    provideAppInitializer(() => {
        const initializerFn = (() => defineCustomerExperienceComponent)();
        return initializerFn();
      }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class SearchModule {
}
